import React, { useState } from 'react'
import styles from './login.module.scss'
import GoogleIcon from './GoogleIcon';

const SignupForm = () => {
    const [username, setUsername] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [phone, setPhone] = useState('');

    return (


        <form className={styles.loginForm}>


            <div style={{ marginBottom: '1rem' }} className={`${styles.inputGroup} relative`}>
                <label htmlFor="username">Name</label>
                <input type="text" id="username" value={username} onChange={(e) => setUsername(e.target.value)} />
            </div>



            <div style={{ marginBottom: '1rem' }} className={`${styles.inputGroup} relative`}>
                <label htmlFor="email">Email</label>
                <input type="email" id="email" value={email} onChange={(e) => setEmail(e.target.value)} />
            </div>

            <div style={{ marginBottom: '1rem' }} className={`${styles.inputGroup} relative`}>
                <label htmlFor="password">Password</label>
                <input type="password" id="password" value={password} onChange={(e) => setPassword(e.target.value)} />
            </div>

            <button type="submit" className={styles.submitButton}>Login</button>

            <div className={styles.divider}>
                <span>or</span>
            </div>


            <button
                type="button"
                className={styles.googleButton}

            >
                <GoogleIcon />
                <span>Sign up with Google</span>
            </button>



        </form>


    )
}

export default SignupForm
